export const isMobile = (): boolean => {
  return window.IS_MOBILE || window.IS_MOBILEWEB;
};

export const isLargeFormatDevice = (): boolean => {
  const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  // const height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  return width > 800 || !window.IS_MOBILE;
};